<template>
  <div>
    <!-- Search Box -->
    <div class="fast-filter px-3 pt-3 d-flex">
      <div
        class="fast-filter__search-action px-2 cursor-pointer"
        :class="{ 'fast-filter__search-action--open': isAdvanceOpen }"
        @click="onOpenAdvanceFilter"
      >
        <em class="fal fa-sliders-v color-white" />
      </div>
      <custom-input
        v-model="filter.searchText"
        :placeholder="$t('EnterRequestNumber')"
        ref="fastSearchInput"
        prepend-icon="fa fa-search"
        prepend-icon-type="success"
        :prepend-icon-left="false"
        class="fast-filter__search-input w-100"
        :prependIconClick="emitFastSearch"
      />
    </div>

    <!-- Advanced Filters -->
    <div v-if="isAdvanceOpen" class="mx-2 px-1">
      <custom-separator text="Filtros" class="case-separator mt-3" />
      <div ref="advancedFilters" class="advanced-filter-container">
        <div class="row">
          <div class="col-12 mt-3">
            <custom-input
              :label="`${$t('RequesterName')}:`"
              class="input__exteded"
              v-model="filter.requesterName"
            />
          </div>
          <div class="col-6 mt-3">
            <custom-date-picker
              v-model="filter.dateFrom"
              class="input__exteded"
              :label="`${$t('From')}:`"
              placeholder="DD/MM/YYYY"
              class-container="w-100"
            />
          </div>
          <div class="col-6 mt-3">
            <custom-date-picker
              v-model="filter.dateTo"
              class="input__exteded"
              :label="`${$t('To')}:`"
              placeholder="DD/MM/YYYY"
              class-container="w-100"
            />
          </div>
          <div class="col-6 mt-3">
            <custom-drop-down
              :label="`${$t('Status.HeaderText')}:`"
              :placeholder="$t('Item-Empty')"
              :options="catalog.itemStatuses"
              fieldkey="id"
              fieldname="name"
              class="case-info__dropdown input__exteded"
              v-model="filter.status"
            />
          </div>
          <div class="col-6 mt-3">
            <custom-input
              class="input__exteded"
              :label="`${$t('Email')}:`"
              v-model="filter.email"
            />
          </div>
          <div class="col-6 mt-3">
            <custom-input
              class="input__exteded"
              :label="`${$t('PhoneNumber')}:`"
              v-model="filter.phone"
            />
          </div>
          <div class="col-6 mt-3">
            <custom-drop-down
              :label="`${$t('SearchMode')}:`"
              :placeholder="$t('Item-Empty')"
              :options="catalog.searchOptions"
              fieldkey="id"
              fieldname="name"
              class="case-info__dropdown input__exteded"
              v-model="filter.searchScope"
              @input="() => {}"
              :disabled="isUserRoleApplicant"
            />
          </div>
          <div class="col-6 mt-3">
            <custom-drop-down
              :label="`${$t('RegionHeader.HeaderText')}:`"
              :placeholder="$t('Item-Empty')"
              :options="catalog.regions"
              fieldkey="id"
              fieldname="name"
              class="case-info__dropdown input__exteded"
              v-model="filter.region"
            />
          </div>
        </div>
        <div class="row mt-5 mb-3">
          <div class="col">
            <action-button
              class="outline-danger btn-cancel danger px-3 mb-2 w-100"
              :text="$t('Close')"
              i="fa fa-times-circle"
              @click="onCancelHandler"
            />
          </div>
          <div class="col">
            <action-button
              class="success px-4 w-100"
              :text="$t('Search')"
              i="fa fa-search"
              @click="onAdvanceSearchHandler"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Applied Filters -->
    <div
      class="bg-white-light rounded p-2 mx-3 mt-2 text-center"
      v-if="!isAdvanceOpen && filterItems.length > 0"
    >
      <div
        v-for="(item, index) in filterItems"
        :key="`filter-item-${index}`"
        class="filter-items__item bg-white mb-2 mx-1 d-inline-block"
      >
        <div class="d-flex align-items-center">
          <span class="color-black font-14 font-weight-bold pl-0">
            {{ item.name }}
          </span>
          <span class="color-black font-14 ml-1">
            {{ item.value }}
          </span>
          <em
            v-if="canDeleteFilter(item)"
            class="fal fa-times-circle ml-3 font-20"
            @click="removeFilterTagHandler(index, item)"
          />
        </div>
      </div>
      <div>
        <action-button
          class="outline-secondary px-3 mb-2 mt-3"
          :text="$t('DeleteCriteria')"
          i="fal fa-minus-circle"
          @click="removeFiltersHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomSeparator from 'custom-separator';
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';
import ActionButton from 'ActionButton';

//services
import { getInitCatalog as _getInitCatalog } from '@/services/app.api.js';

//utils
import { date } from '@/filters/index.js';
import { i18n } from '@/i18n.js';

//constants
import langTypes from '@/utils/constants/lang.js';
const SEARCH_SCOPE_FILTER_KEY = 'searchScope';

export default {
  name: 'RequestFilter',
  components: {
    CustomInput,
    CustomSeparator,
    CustomDropDown,
    CustomDatePicker,
    ActionButton,
  },
  props: {},
  data: () => ({
    isAdvanceOpen: false,
    filter: {
      searchText: null,
      requesterName: null,
      dateFrom: null,
      dateTo: null,
      status: null,
      email: null,
      phone: null,
      searchScope: null,
      subType: null,
      region: null,
    },
    filterItems: {},
    catalog: {
      itemStatuses: [],
      itemSubTypes: [],
      regions: [],
      searchCriteriaTypes: [],
      searchOptions: [],
    },
  }),
  async mounted() {
    await this.getInitCatalog();
  },
  computed: {
    isEnLang() {
      return this.userSelectedLang === langTypes.EN;
    },
    canDeleteFilter() {
      return (item) => {
        return !(
          this.isUserRoleApplicant && item.key === SEARCH_SCOPE_FILTER_KEY
        );
      };
    },
  },
  methods: {
    async getInitCatalog() {
      this.catalog = (await _getInitCatalog(this.isEnLang)).data;
      this.filter.searchScope = this.catalog.searchOptions.find(
        (so) => so.selected
      );
    },
    emitFastSearch() {
      this.emitSearch(this.filter.searchText || null);
    },
    toggleFilterPanelVisibility() {
      this.isAdvanceOpen = !this.isAdvanceOpen;
    },
    onOpenAdvanceFilter() {
      this.toggleFilterPanelVisibility();
    },
    onAdvanceSearchHandler(toggle = true) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);  
 
      if (this.filter.dateFrom) {
        const fromDate = new Date(this.filter.dateFrom);
        fromDate.setHours(0, 0, 0, 0);

        if (fromDate > today) {
          this.filter.dateFrom = null;
          alert('La fecha de inicio no puede ser mayor que la fecha actual.');
          return;
        }
      }

      if (this.filter.dateTo) {
        const toDate = new Date(this.filter.dateTo);
        toDate.setHours(0, 0, 0, 0);

        if (toDate > today) {
          this.filter.dateTo = null;
          alert('La fecha de fin no puede ser mayor que la fecha actual.');
          return;
        }
      }
 
      if (this.filter.dateFrom && this.filter.dateTo) {
        const fromDate = new Date(this.filter.dateFrom);
        const toDate = new Date(this.filter.dateTo);

        if (fromDate > toDate) {
          this.filter.dateTo = null;
          alert('Fecha de inicio no puede ser mayor que la fecha de fin.');
          return;
        }
      }
 
      this.filterItems = this.convertFilterToArray({
        requesterName: this.filter.requesterName,
        dateFrom: this.filter.dateFrom ? date(this.filter.dateFrom) : null,
        dateTo: this.filter.dateTo ? date(this.filter.dateTo) : null,
        status: this.filter.status?.name || null,
        email: this.filter.email,
        phone: this.filter.phone,
        searchScope: this.filter.searchScope?.name || null,
        subType: null,
        region: this.filter.region?.name || null,
      });

      if (toggle) this.toggleFilterPanelVisibility();
      this.emitSearch();
      this.$emit('on-dashboard-update');
    },
    convertFilterToArray(params) {
      const getLabelByKey = (key) => {
        switch (key) {
          case 'requesterName':
            return `${i18n.t('RequesterName')}:`;
          case 'dateFrom':
            return `${i18n.t('From')}:`;
          case 'dateTo':
            return `${i18n.t('To')}:`;
          case 'status':
            return `${i18n.t('Status.HeaderText')}:`;
          case 'email':
            return `${i18n.t('Email')}:`;
          case 'phone':
            return `${i18n.t('PhoneNumber')}:`;
          case 'searchScope':
            return `${i18n.t('SearchMode')}:`;
          case 'subType':
            return `${i18n.t('Subtype')}:`;
          case 'region':
            return `${i18n.t('RegionHeader.HeaderText')}:`;
          default:
            return '';
        }
      };

      const filterArray = Object.entries(params)
        .filter((x) => x[1])
        .map((x) => ({
          name: getLabelByKey(x[0]),
          value: x[1],
          key: x[0],
        }));

      return filterArray;
    },
    removeFilterTagHandler(itemIndex, tagFilter) {
      this.filterItems.splice(itemIndex, 1);
      this.filter[tagFilter.key] = null;
      this.emitSearch();
    },
    removeFiltersHandler() {
      this.filterItems = [
        ...this.filterItems.filter(
          (x) => this.isUserRoleApplicant && x.key === SEARCH_SCOPE_FILTER_KEY
        ),
      ];
      const _filter = { ...this.filter };
      this.filter = {
        requesterName: null,
        dateFrom: null,
        dateTo: null,
        status: null,
        email: null,
        phone: null,
        searchScope: this.isUserRoleApplicant
          ? _filter[SEARCH_SCOPE_FILTER_KEY]
          : null,
        subType: null,
        region: null,
      };
      this.emitSearch();
    },
    onCancelHandler() {
      this.toggleFilterPanelVisibility();
    },
    emitSearch(searchText = null) {
      this.$emit('on-advance-search', { ...this.filter, searchText });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/custom-separator/index.scss';

.fast-filter {
  &__search-action {
    background: #1da7af;
    border: 1px solid #1da7af;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    margin-left: -5px;
    margin-right: -3px;
    z-index: 9;
    &--open {
      background: #0f556a !important;
      border: 1px solid #0f556a;
    }
  }

  &__search-input ::v-deep {
    input {
      background: #f8ffff;
      border: 1px solid #97dade;
    }
    .input-group-text {
      background: #f3aa1c !important;
      border: none !important;
      i {
        color: #fff;
      }
    }
  }
}

.filter-items {
  &__item {
    border: 1px solid #aabbb4;
    border-radius: 30px;
    padding: 3px 15px 2px 15px;
    em {
      color: #f3aa1c;
      cursor: pointer;
    }
  }
}

.input__exteded ::v-deep {
  .data-label,
  .data-name {
    color: #0f5a6e;
    font-size: 14px;
  }
  .fa-calendar-day {
    color: #1da7af !important;
  }
  input,
  .vs__dropdown-toggle {
    &:not(.vs__search) {
      background: #f8ffff !important;
      border: 1px solid #97dade !important;
    }
  }
}
</style>
